var window=global;var $CLJS=require("./cljs_env");require("./goog.base.js");
$CLJS.NA=require("ttag");module.exports=$CLJS.NA;